<template>
  <div v-if="product">
    <div v-if="!isLoading">
      <div class="d-flex showcase">
        <div class="photos bd-highlight mr-4" v-if="product.slides.length">
          <VueSlickCarousel v-bind="settings" :focusOnSelect="true">
            <template v-for="(slide, index) in product.slides">
              <div class="slick-item" :key="index" @click="changeSlide(index)">
                <img :src="slide" alt="" />
              </div>
            </template>
          </VueSlickCarousel>
        </div>
        <div class="preview bd-highlight">
          <img v-if="product.cover" ref="cover" :src="product.cover" alt="" />
          <img v-else ref="cover" src="@/assets/img/pexels-photo-106399.jpeg" alt="" />
        </div>
        <div v-if="product" class="info flex-grow-1 bd-highlight">
          <div class="flex-grow-1">
            <h2>{{ product.name }}</h2>
            <div class="category">
              <span>Danh mục: </span>
              <span class="cursor-pointer" @click.stop="filterByCategory(product.category_id)">{{ product.category_name
                }}</span>
            </div>
            <div class="flex">
              <div class="brand">
                <span>Thương hiệu: </span>
                <span class="cursor-pointer" @click.stop="filterByBrand(product.brand_id)">{{ product.brand_name
                  }}</span>
              </div>
              <div class="gender right-column">
                <span>Giới tính: </span>
                <span class="cursor-pointer" @click.stop="filterByGender(product.gender_id)">{{ genderName() }}</span>
              </div>
            </div>
            <div class="flex">
              <div class="available-status">
                <span>Trạng thái: </span>
                <span class="order cursor-pointer" @click.stop="filterByState(product.state_id)">{{ product.state_name }}</span>
              </div>
              <div class="price right-column">
                <span>Giá: </span>
                <span v-if="product.price">{{ Number(product.price).toLocaleString() }} VND</span>
                <span v-else>Liên hệ</span>
              </div>
            </div>
            <div class="size">
              <span>Kích thước: </span>
              <span>{{ product.size }}</span>
            </div>
            <div class="description">
              <span>Mô tả:</span>
              <span>
                {{ product.description }}
              </span>
            </div>
            <p class="ads" v-html="product.ads"></p>
            <div class="actions">
              <PrimaryButton caption="Liên hệ đặt mua" @onClick="order()" />
            </div>
          </div>
        </div>
      </div>
      <RelatedProducts :products="relatedProducts" />
    </div>
    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("publicStoreModule");

import RelatedProducts from "./components/RelatedProducts.vue";
import Loading from "./components/Loading.vue";
import PrimaryButton from "./components/PrimaryButton.vue";
import { genders } from "../../config/constants";

import { ShowCategory as ApiShowCategory } from "@/api/categories";
import { ShowBrand as ApiShowBrand } from "@/api/brands";
import { ShowState as ApiShowState } from "@/api/states";

export default {
  components: {
    VueSlickCarousel,
    RelatedProducts,
    Loading,
    PrimaryButton,
  },
  data() {
    return {
      settings: {
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 1660,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              vertical: true,
              verticalSwiping: true,
              arrows: true,
            },
          },
          {
            breakpoint: 1279,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              vertical: true,
              verticalSwiping: true,
              arrows: true,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              vertical: false,
              verticalSwiping: false,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              vertical: false,
              verticalSwiping: false,
              arrows: false,
            },
          },
        ],
      },
    };
  },
  created() {
    const productId = this.$route.params.id;
    productId && this.getProduct(productId);
  },
  methods: {
    ...mapActions(["getProducts", "getProduct", "commitFilter"]),

    changeSlide(index) {
      const { slides } = this.product;
      this.$refs.cover.setAttribute("src", slides[index]);
    },
    order() {
      window.open("https://zalo.me/0937776602", "_blank");
    },
    genderName() {
      return genders.find(gender => gender.id == this.product.gender_id).name;
    },
    filterByCategory(category_id) {
      const params = { filter: { category_id: category_id }, page: 1 };
      // this.getProducts(params);
      ApiShowCategory({ id: category_id })
        .then((response) => {
          this.$router.push({ name: "front.home.category", params: { id: category_id, params: params, name: response.data.name } }).catch(() => { });
        })
        .catch(() => {});
      
    },
    filterByBrand(brand_id) {
      const params = { filter: { brand_id: brand_id }, page: 1 };
      // this.getProducts(params);
      ApiShowBrand({ id: brand_id })
        .then((response) => {
          this.$router.push({ name: "front.home.brand", params: { id: brand_id, params: params, name: response.data.name } }).catch(() => { });
        })
        .catch(() => {});
    },
    filterByState(state_id) {
      const params = { filter: { state_id: state_id }, page: 1 };
      // this.getProducts(params);
      ApiShowState({ id: state_id })
        .then((response) => {
          this.$router.push({ name: "front.home.state", params: { id: state_id, params: params, name: response.data.name } }).catch(() => { });
        })
        .catch(() => {});
    },
    filterByGender(gender_id) {
      const params = { filter: { gender_id: gender_id }, page: 1 };
      // this.getProducts(params);
      this.$router.push({ name: "front.home.gender", params: { id: gender_id, params: params, name: genders.find(g => g.id == gender_id).name } }).catch(() => { });
    }
  },
  computed: {
    ...mapState(["product", "isLoading", "relatedProducts"]),
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.showcase {
  position: relative;
  display: flex;
  .flex {
    display: flex
  }
  .right-column {
    padding-left: 10px;
  }
  .photos {
    max-width: 200px;
    max-height: 600px;
    overflow: hidden;
    margin-right: 10px;
    padding-top: 20px;
    padding-bottom: 26px;
  }
  ::v-deep .slick-slider {
    height: 472px;
    position: relative;
    padding: 16px 0;
    .slick-arrow.slick-next {
      position: absolute;
      top: -5px;
      left: 50%;
      transform: translateX(-50%) rotate(270deg);
    }
    .slick-arrow.slick-prev {
      position: absolute;
      left: 50%;
      top: 447px;
      transform: translateX(-50%) rotate(-90deg);
    }
  }
  .slick-item {
    img {
      width: 200px;
      height: 100px;
      object-fit: cover;
    }
  }
  .preview {
    margin-right: 10px;
    padding-top: 36px;
    img {
      margin-top: 1px;
      width: 500px;
      height: 500px;
      object-fit: cover;
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    height: 480px;
    position: relative;
    padding-top: 36px;
    .category {
      color: #000;
      font-size: 20px;
      margin-bottom: 10px;
      span:nth-child(2) {
        color: #d39999 !important;
      }
    }
    .brand {
      color: #000;
      font-size: 20px;
      margin-bottom: 10px;
      span:nth-child(2) {
        color: #d39999 !important;
      }
    }
    .gender {
      color: #000;
      font-size: 20px;
      margin-bottom: 10px;
      span:nth-child(2) {
        color: #d39999 !important;
      }
    }
    .size {
      color: #000;
      font-size: 20px;
      margin-bottom: 10px;
      span:nth-child(2) {
        color: #d39999 !important;
      }
    }
    .available-status {
      color: #000;
      font-size: 20px;
      // text-transform: uppercase;
      margin-bottom: 10px;
      .available {
        color: #50e443;
      }
      .order {
        color: #d39999;
      }
    }
    .price {
      color: #000;
      font-size: 20px;
      margin-bottom: 10px;
      span:nth-child(2) {
        color: #d39999 !important;
      }
    }
    .ads {
      margin-top: 10px;
      font-size: 16px;
      border: 4px solid #000;
      padding: 8px;
      text-align: center;
    }
    .description {
      font-size: 20px;
      margin-bottom: 10px;
      height: 68px;
      // overflow-y: scroll;
      color: #000;
    }
    .actions {
      position: absolute;
      // bottom: 0;
      margin-top: 15px;
      left: 0;
    }
  }
}
@media screen and (max-width: 1660px) and (min-width: 1279px) {
  .showcase {
    padding: 30px 80px 0 80px;

    .photos {
      max-width: 125px;
      max-height: 500px;
    }
    .preview {
      img {
        width: 500px;
        height: 500px;
        object-fit: cover;
      }
    }
    .info {
      height: 480px;
      .category,
      .brand,
      .available-status,
      .price,
      .gender,
      .size,
      .description
      .group {
        margin-bottom: 2px;
      }
      h2 {
        font-size: 24px;
      }
      span {
        font-size: 18px;
      }
    }
  }
}
@media screen and (max-width: 1279px) and (min-width: 769px) {
  .showcase {
    padding: 20px 60px 0 60px;

    flex-wrap: wrap;
    .photos {
      max-width: 180px;
      max-height: 380px;
      ::v-deep .slick-slider {
        .slick-arrow.slick-prev {
          top: 340px;
        }
      }
    }
    .preview {
      img {
        max-width: 490px;
        height: 319px;
        object-fit: cover;
      }
    }
    .info {
      height: 370px;

      flex: 1 1 100%;

      .category,
      .brand,
      .available-status,
      .price,
      .gender,
      .size,
      .description
      .group {
        margin-bottom: 2px;
      }
      h2 {
        font-size: 23px;
      }
      span {
        font-size: 18px;
      }      
    }
  }
}
@media screen and (max-width: 768px) and (min-width: 481px) {
  .showcase {
    padding: 10px 40px 0 40px;
    flex-direction: column;
    .photos {
      max-width: 100%;
      ::v-deep .slick-slider,
      ::v-deep .slick-list {
        height: 120px !important;
      }
      img {
        width: 200px;
        height: 200px;
      }
    }
    .preview {
      margin-left: unset;
      margin-bottom: 30px;
      padding-top: 16px;
      img {
        width: 100%;
        min-height: 380px;
        max-height: 400px;
      }
    }
    .info {
      height: 325px;
      padding-top: 16px;
      .category,
      .brand,
      .available-status,
      .size,
      .price,
      .description,
      .group {
        margin-bottom: 2px;
      }
      h2 {
        font-size: 23px;
      }
      span {
        font-size: 18px;
      }
    }
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
  .showcase {
    flex-direction: column;
    .photos {
      max-width: 100%;
      ::v-deep .slick-slider,
      ::v-deep .slick-list {
        height: 100px !important;
      }
      img {
        width: 100px;
        height: 100px;
      }
    }
    .preview {
      margin-left: unset;
      margin-bottom: 30px;
      padding-top: 0;
      img {
        width: 100%;
        min-height: 280px;
        max-height: 300px;
      }
    }
    .info {
      padding-top: 0;
      h2 {
        font-size: 22px;
      }
      .category, .brand, .price, .available-status, .size, .gender, .description {
        span {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
